import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDollar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 16,
	viewBox: "0 0 10 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.18519 5.03696C8.03774 4.61861 7.76848 4.25397 7.41205 3.98995C7.05562 3.72592 6.62834 3.57461 6.18518 3.55547H3.22222C2.63285 3.55547 2.06762 3.7896 1.65087 4.20635C1.23413 4.6231 1 5.18833 1 5.7777C1 6.36707 1.23413 6.9323 1.65087 7.34905C2.06762 7.76579 2.63285 7.99992 3.22222 7.99992H6.18518C6.77455 7.99992 7.33979 8.23405 7.75653 8.65079C8.17328 9.06754 8.40741 9.63277 8.40741 10.2221C8.40741 10.8115 8.17328 11.3767 7.75653 11.7935C7.33979 12.2102 6.77455 12.4444 6.18518 12.4444H3.22222C2.77907 12.4252 2.35178 12.2739 1.99536 12.0099C1.63893 11.7459 1.36966 11.3812 1.22222 10.9629M4.7037 1.33325V3.55547M4.7037 12.4444V14.6666",
		stroke: "#66798D",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDollar;
